import { Box, Flex, Grid, Icon, Image, Input, Text } from "@chakra-ui/react";

import { ContactPage } from "./home/pages/contactUs";
import DOWNLOAD from "src/resources/images/download_icon.png";
import DynamicBreadcrumb from "src/common/dynamicBreadCrumb";
import HomeNavbar from "./home/homeNavbar";
import PDF_ICON from "src/resources/images/pdf_icon.png";
import SEND from "src/resources/images/send_icon.png";
import { ScrollRestoration } from "react-router-dom";
import { SearchIcon } from "@chakra-ui/icons";
import { useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "src/store/store";
import { EnglishLabels } from "src/common/constants/englishLabels";
import { HindiLabels } from "src/common/constants/hindiLabels";



export const LegalDocuments = () => {
  const [searchQuery, setSearchQuery] = useState(""); // State for search input

   const globalLanguage = useSelector(
  (state: RootState) => state.globalInfo.globalLanguage
  );
  const isHindi = globalLanguage === "HI";
  const t = isHindi ? HindiLabels : EnglishLabels;


  const documentTitles = [
    t.Community_Guidelines,
    t.Terms_Conditions,
    t.Matrimony_Guidelines,
    t.Approval_Process,
  ];

  // Handle search input change
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  // Filter document titles based on search query
  const filteredDocuments = documentTitles.filter((title) =>
    title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div>
      <ScrollRestoration />
      {/* Navbar Section */}
      <Box
        mt={-2}
        position="sticky"
        zIndex="1000"
        width="100%"
        background="#FFF"
        transition="top 0.3s ease-in-out, background 0.3s ease-in-out"
      >
        <HomeNavbar
          scrollToAbout={() => {}}
          scrollToEvents={() => {}}
          scrollToSanstha={() => {}}
          scrollToContact={() => {}}
          isScrolled={true}
          activeSection=""
        />
      </Box>
      <Box width="100%" p={10} pt={24}>
        <DynamicBreadcrumb />
      </Box>
      {/* Legal Documents Section */}
      <Box
        width="100%"
        height="100%"
        p="40px"
        bg="white"
        marginTop="inherit"
        pt="0px"
      >
        {/* Header Section */}
        <Flex
          justify="space-between"
          align="center"
          gap="20px"
          direction={{ base: "column", md: "row" }}
        >
          <Text
            fontSize={{ base: "24px", md: "32px" }}
            fontWeight="700"
            fontFamily="PP Neue Montreal"
            color="#08090A"
            mb={{ base: "20px", md: "0" }}
          >
            {t.Legal_Documents}
          </Text>
          <Flex
            width={{ base: "100%", sm: "90%", md: "390px" }}
            height="40px"
            borderRadius="8px"
            border="1px solid #BFBFBF"
            align="center"
            p="10px 12px"
          >
            <Input
              value={searchQuery}
              onChange={handleSearchChange}
              placeholder="Search documents"
              size="sm"
              variant="unstyled"
              color="rgba(14, 15, 16, 0.99)"
              style={{ fontWeight: "bold" }}
            />
            <Icon as={SearchIcon} boxSize={4} color="#BFBFBF" />
          </Flex>
        </Flex>

        {/* Document Cards Section */}
        <Grid
          templateColumns={{
            base: "1fr", // 1 column for base size (mobile)
            sm: "1fr", // 1 column for small screens
            md: "repeat(2, 1fr)", // 2 columns for medium screens (tablets)
            lg: "repeat(3, 1fr)", // 3 columns for large screens (desktop)
          }}
          gridColumnGap="58px"
          gridRowGap="60px"
          mt="32px"
          justifyItems="center"
        >
          {filteredDocuments.map((title, index) => (
            <Box
              key={index}
              width="100%"
              maxWidth="361px"
              borderRadius="8px"
              overflow="hidden"
              border="1px solid #E9E9E9"
            >
              {/* Image Section */}
              <Box
                bg="#F6F6F6"
                height="320px"
                display="flex"
                justifyContent="center"
                alignItems="flex-end"
                p="10px"
              >
                <Image
                  src={PDF_ICON}
                  alt={title}
                  width="72px"
                  height="72px"
                  align="center"
                  marginBottom="124px"
                />
              </Box>

              {/* Title and Icons Section */}
              <Flex
                p="12px"
                border="1px solid #E9E9E9"
                display="flex"
                justify="space-between"
                align="center"
                gap="20px"
                flexDirection={{ base: "column", sm: "row" }}
              >
                <Text
                  fontSize="20px"
                  fontWeight="500"
                  lineHeight="32px"
                  color="#3D3D3D"
                  flex="1"
                  mb={{ base: "10px", sm: "0" }}
                >
                  {title}
                </Text>

                {/* Left Icon */}
                <Flex
                  width="24px"
                  height="24px"
                  direction="column"
                  align="center"
                  justify="center"
                >
                  <Box width="24px" height="24px" mb="2px">
                    <Image src={SEND} />
                  </Box>
                </Flex>

                {/* Right Icon */}
                <Flex
                  width="24px"
                  height="24px"
                  direction="column"
                  align="center"
                  justify="center"
                >
                  <Box width="24px" height="24px" mb="2px">
                    <a href="/Dummy File.pdf" download>
                      <Image src={DOWNLOAD} alt="Download PDF" />
                    </a>
                  </Box>
                </Flex>
              </Flex>
            </Box>
          ))}
        </Grid>
      </Box>

      {/* Contact Us Section */}
      <Box h="100%" w="100%">
        <ContactPage />
      </Box>
    </div>
  );
};
